import { useState, ReactNode } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, AccordionProps } from '@mui/material';

import { Arrow, Title } from './SingleAccordion.styles';

interface SingleAccordionProps {
  title: string;
  children: ReactNode;
  callback?: () => void;
}

const SingleAccordion = ({
  title,
  callback,
  children,
  ...props
}: SingleAccordionProps & AccordionProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOnChange = () => {
    const nextValue = !isOpen;
    setIsOpen(nextValue);
    if (nextValue && callback) {
      callback();
    }
  };

  return (
    <Accordion
      expanded={isOpen}
      onChange={handleOnChange}
      TransitionProps={{ unmountOnExit: true }}
      {...props}
    >
      <AccordionSummary expandIcon={<Arrow />}>
        <Title variant="h5">{title}</Title>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};

export default SingleAccordion;
